import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { map } from "leaflet";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import { MatDatepicker } from "@angular/material/datepicker";
@Component({
  selector: "app-manager-invoice",
  templateUrl: "./manager-invoice.component.html",
  styleUrls: ["./manager-invoice.component.scss"],
})
export class ManagerInvoiceComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    private router: Router // private modalService: NzModalService, // private notification: NzNotificationService
  ) {}
  searchTerm;
  listData = [];
  selectedFile: File | null = null;
  pageSize = 10;
  pageIndex = 1;
  params = "";
  searching;
  totalCount = 0;
  tableName = "electronic-invoice/list";
  role = JSON.parse(localStorage.getItem("currentUser"))["role"];
  full_name = JSON.parse(localStorage.getItem("currentUser")).full_name;
  submitted: boolean;
  formData: FormGroup;
  listStatus = [
    { value: "created", label: "Đã tạo" },
    { value: "not_created", label: "Chưa tạo" },
    { value: "error", label: "Lỗi" },
  ];
  listDevice = [
    { value: "4g", label: "Loa 4G" },
    { value: "wifi", label: "Loa WIFI" },
  ];
  listPackage = [
    { value: "3", label: "3 tháng" },
    { value: "6", label: "6 tháng" },
    { value: "12", label: "12 tháng" },
  ];
  listDayRange = [
    { value: 3, label: "3 ngày" },
    { value: 7, label: "7 ngày" },
    { value: 14, label: "14 ngày" },
  ];
  listAff = [
    { value: "VCC", label: "Viettel" },
    { value: "DNS", label: "DNS" },
  ];
  breadCrumbItems;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  listDevices;
  get form() {
    return this.formData.controls;
  }
  filter = {
    type_id: "",
    phone: "",
    month: "",
    year: "",
    device_type: "",
    package: "",
    invoice_no: "",
    recipientPhone: "",
    status: "",
    deliveryMethod: "",
    startDay: null,
    endDay: null,
    send_count: null,
    dayRange: "",
    referrer: "",
    terminal_bank_acc: "",
    serial_number: "",
  };

  ngOnInit() {
    this.fetchData();
    this.range.valueChanges.subscribe((rangeValues) => {
      const formatDate = (date: Date | null) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      this.filter.startDay = formatDate(rangeValues.start);
      this.filter.endDay = formatDate(rangeValues.end);
    });
  }
  date = new FormGroup({
    selectedMonth: new FormControl(null), // Không dùng <Date | null>
  });

  selectedMonth: { month: string; year: string } | null = null;
  onMonthSelected(event: Date, datepicker: MatDatepicker<Date>) {
    const year = event.getFullYear();
    const month = event.getMonth(); // Không cần +1 vì Date đã đúng format

    // Gán giá trị vào FormControl
    this.date.controls["selectedMonth"].setValue(new Date(year, month, 1));

    console.log("📅 Tháng được chọn:", { month: month + 1, year });

    datepicker.close(); // Đóng datepicker sau khi chọn
  }
  getStatusLabel(status: string): string {
    const found = this.listStatus.find((item) => item.value === status);
    return found ? found.label : "Không xác định";
  }
  exportOrderInfo() {
    this.eventService.setLoading(true);

    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = "electronic-invoice/export-order-invoice";

    const payload: any = {};
    Object.keys(this.filter).forEach((key) => {
      if (this.filter[key]) {
        payload[key] = this.filter[key];
      }
    });
    const queryParams = new URLSearchParams(payload).toString();
    this.http
      .get(`${url}?${queryParams}`, { headers, responseType: "blob" })
      .subscribe({
        next: (res: Blob) => {
          this.eventService.setLoading(false);
          saveAs(res, "Danhsachdonhang.xlsx");
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant(
              "Xuất thông tin ds đơn hàng thành công"
            )
          );
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Xuất thông tin đơn hàng thất bại")
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }
  exportCCCD() {
    this.eventService.setLoading(true);

    const headers = new HttpHeaders({
      "Content-Type": "text/plain",
      Accept: "text/plain",
    });

    const url = "electronic-invoice/export-cccd";

    const payload: any = {};
    Object.keys(this.filter).forEach((key) => {
      if (this.filter[key]) {
        payload[key] = this.filter[key];
      }
    });

    const queryParams = new URLSearchParams(payload).toString();
    this.http
      .get(`${url}?${queryParams}`, { headers, responseType: "blob" })
      .subscribe({
        next: (res: Blob) => {
          this.eventService.setLoading(false);

          // Tạo và lưu file sử dụng FileSaver
          saveAs(res, "CCCD.txt");
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Xuất file CCCD thành công")
          );
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Xuất file CCCD thất bại")
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }
  importCCCD(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file, file.name);

      this.eventService.setLoading(true);
      this.http.post("electronic-invoice/import-tax-code", formData).subscribe({
        next: (res) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant(
              `Tổng số: ${res["metadata"].totalResults}, tạo thành công: ${res["metadata"].countSuccess}`
            )
          );
          this.fetchData();
        },
        error: (error) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Nhập file thất bại")
          );
          console.error("Error importing file", error);
        },
      });
    } else {
      console.error("No file selected");
    }
  }
  importOrderInfo(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file, file.name);

      this.eventService.setLoading(true);
      this.http
        .post("electronic-invoice/import-release-list", formData)
        .subscribe({
          next: (response) => {
            this.eventService.setLoading(false);
            this.apiService.showToastMobile(
              this.translateService.instant("success"),
              this.translateService.instant("Nhập file thành công")
            );
            this.fetchData();
          },
          error: (error) => {
            this.eventService.setLoading(false);
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Nhập file thất bại")
            );
            console.error("Error importing file", error);
          },
        });
    } else {
      console.error("No file selected");
    }
  }
  UpdateBatchInvoice() {
    // Kiểm tra nếu filter không có giá trị nào
    const hasFilterValue = Object.values(this.filter).some(
      (value) => value !== null && value !== undefined && value !== ""
    );
    if (!this.filter.startDay || !this.filter.endDay) {
      this.apiService.showToastMobile(
        "error",
        this.translateService.instant(
          "Vui lòng chọn ngày bắt đầu và ngày kết thúc trước khi tạo danh sách hoá đơn"
        )
      );
      return;
    }
    // if (!hasFilterValue) {
    //   this.apiService.showToastMobile(
    //     "error",
    //     this.translateService.instant("Vui lòng chọn ít nhất một bộ lọc trước khi tạo danh sách hoá đơn")
    //   );
    //   return;
    // }

    this.eventService.setLoading(true);
    const url = "electronic-invoice/update-invoice-transaction-uuid";
    const payload: any = {};
    Object.keys(this.filter).forEach((key) => {
      if (this.filter[key]) {
        payload[key] = this.filter[key];
      }
    });

    this.http.post(url, payload).subscribe({
      next: (res) => {
        this.eventService.setLoading(false);
        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant(
            `Tổng số: ${res["metadata"].totalResults}, tạo thành công: ${res["metadata"].countSuccess}`
          )
        );
        this.fetchData();
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất danh sách hoá đơn thất bại")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  CreateBatchInvoice() {
    // Kiểm tra nếu filter không có giá trị nào
    const hasFilterValue = Object.values(this.filter).some(
      (value) => value !== null && value !== undefined && value !== ""
    );
    if (!this.filter.startDay || !this.filter.endDay) {
      this.apiService.showToastMobile(
        "error",
        this.translateService.instant(
          "Vui lòng chọn ngày bắt đầu và ngày kết thúc trước khi tạo danh sách hoá đơn"
        )
      );
      return;
    }
    // if (!hasFilterValue) {
    //   this.apiService.showToastMobile(
    //     "error",
    //     this.translateService.instant("Vui lòng chọn ít nhất một bộ lọc trước khi tạo danh sách hoá đơn")
    //   );
    //   return;
    // }

    this.eventService.setLoading(true);
    const url = "electronic-invoice/create-list";
    const payload: any = {};
    Object.keys(this.filter).forEach((key) => {
      if (this.filter[key]) {
        payload[key] = this.filter[key];
      }
    });

    const queryParams = new URLSearchParams(payload).toString();
    this.http.post(`${url}?${queryParams}`, {}).subscribe({
      next: (res) => {
        this.eventService.setLoading(false);
        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant(
            `Tổng số: ${res["metadata"].totalResults}, tạo thành công: ${res["metadata"].countSuccess}`
          )
        );
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất danh sách hoá đơn thất bại")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  CreateDraftBatchInvoice() {
    // Kiểm tra nếu filter không có giá trị nào
    const hasFilterValue = Object.values(this.filter).some(
      (value) => value !== null && value !== undefined && value !== ""
    );
    if (!this.filter.startDay || !this.filter.endDay) {
      this.apiService.showToastMobile(
        "error",
        this.translateService.instant(
          "Vui lòng chọn ngày bắt đầu và ngày kết thúc trước khi tạo danh sách hoá đơn"
        )
      );
      return;
    }

    this.eventService.setLoading(true);
    const url = "electronic-invoice/create-list-draft";
    const payload: any = {};
    Object.keys(this.filter).forEach((key) => {
      if (this.filter[key]) {
        payload[key] = this.filter[key];
      }
    });

    const queryParams = new URLSearchParams(payload).toString();
    this.http.post(`${url}?${queryParams}`, {}).subscribe({
      next: (res) => {
        this.eventService.setLoading(false);
        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant(
            `Tổng số: ${res["metadata"].totalResults}, tạo thành công: ${res["metadata"].countSuccess}`
          )
        );
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất danh sách hoá đơn thất bại")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  logDateRange(start: Date | null, end: Date | null) {
    console.log("Start date:", start);
    console.log("End date:", end);
  }
  onChangePage(e) {
    this.pageIndex = e;
    this.fetchData();
  }
  exportInvoice(id) {
    this.apiService.getList("electronic-invoice?invoiceNo=" + id).subscribe({
      next: (res: any) => {
        const metadata = res.metadata;
        if (metadata && metadata.fileToBytes && metadata.fileName) {
          const linkSource = `data:application/pdf;base64,${metadata.fileToBytes}`;
          const downloadLink = document.createElement("a");
          const fileName = metadata.fileName;

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();

          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Tải hoá đơn thành công")
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Không tìm thấy file hoá đơn")
          );
        }
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất hoá đơn thất bại")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  exportInvoiceDraft(id) {
    this.apiService
      .getList("electronic-invoice/draft?orderId=" + id)
      .subscribe({
        next: (res: any) => {
          const metadata = res.metadata;
          if (metadata && metadata.fileToBytes && metadata.fileName) {
            const linkSource = `data:application/pdf;base64,${metadata.fileToBytes}`;
            const downloadLink = document.createElement("a");
            const fileName = metadata.fileName;

            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();

            this.apiService.showToastMobile(
              this.translateService.instant("success"),
              this.translateService.instant("Tải hoá đơn nháp thành công")
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Không tìm thấy file hoá đơn")
            );
          }
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Xuất hoá đơn thất bại")
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }
  sentMess(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant(
        "Bạn có chắc chắn muốn gửi tin nhắn tới KH?"
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        this.apiService
          .postItem(`subrenew-zalo-noti`, { id: data.id })
          .subscribe({
            next: () => {
              this.apiService.showToastMobile(
                this.translateService.instant("success"),
                this.translateService.instant("Gửi tin nhắn thành công")
              );
              this.fetchData();
            },
            error: (err) => {
              if (err === "Internal Server Error") {
                this.apiService.showToastMobile(
                  "error",
                  this.translateService.instant("Lỗi máy chủ")
                );
              } else {
                this.apiService.showToastMobile("error", err);
              }
            },
          });
      }
    });
  }
  onLink(data, contentLink) {
    this.getCountDevice(data.id);
    this.formData = this.makeForm(data);
    this.modalService.open(contentLink, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }
  sendToUsers(data: any) {
    const dataPost: any = {
      numberSend: data.data,
    };

    const optionalFields = [
      "acc_number",
      "phone",
      "status",
      "dayRange",
      "send_count",
    ] as const;
    optionalFields.forEach((field) => {
      const value = this.filter[field];
      if (value !== null && value !== undefined && value !== "") {
        dataPost[field] = value;
      }
    });

    this.eventService.setLoading(true);
    this.apiService
      .postItem("subrenew-zalo-noti/cronjob-send", dataPost)
      .subscribe({
        next: (res) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Gửi thành công")
          );
          this.modalService.dismissAll();
          this.fetchData();
        },
        error: (e) => {
          const errMsg = e
            ? this.translateService.instant(e)
            : this.translateService.instant("Gửi thất bại");
          this.apiService.showToastMobile("error", errMsg);
        },
        complete: () => {
          this.eventService.setLoading(false);
        },
      });
  }

  clearFilter() {
    this.params = "";
    this.filter.serial_number = "";
    this.filter.referrer = "";
    this.filter.invoice_no = "";
    this.filter.type_id = "";
    this.filter.status = "";
    this.filter.referrer = "";
    this.filter.recipientPhone = "";
    this.filter.device_type = "";
    this.filter.package = "";
    this.filter.phone = "";
    this.filter.terminal_bank_acc = "";
    this.filter.deliveryMethod = "";
    this.filter.startDay = null;
    this.filter.endDay = null;
    (this.filter.send_count = null),
      (this.filter.dayRange = ""),
      this.range.reset();
    this.pageIndex = 1;
    if (this.full_name.includes("DD")) {
      this.listData = [];
      this.totalCount = 0;
    } else {
      this.listData = [];
      this.totalCount = 0;
    }
    this.fetchData();
  }

  submitFilter() {
    this.params = "";
    Object.keys(this.filter).forEach((key) => {
      if (this.filter[key]) {
        this.params += `&${key}=${this.filter[key]}`;
      }
    });
    if (this.params) {
      this.pageIndex = 1;
      this.searching = true;
      this.fetchData();
    }
  }
  dataHead;
  fetchData() {
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        this.tableName +
          `?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`
      )
      .subscribe({
        next: (res) => {
          this.listData = res.metadata["results"]
            ? res.metadata["results"]
            : [];
          this.dataHead = res.metadata["stats"];

          this.totalCount = res.metadata.pagination.totalCount
            ? res.metadata.pagination.totalCount
            : "";
          this.eventService.setLoading(false);
        },
      });
  }
  countDevice;
  getCountDevice(id) {
    this.apiService
      .getList("cs/device-subscription?customerOrderId=" + id)
      .subscribe({
        next: (res) => {
          this.formData.patchValue({
            quantity: res.metadata.missingDevices,
          });
        },
      });
  }
  excelData: any;

  onFileChange(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  // Gửi file lên server
  uploadFile() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append("file", this.selectedFile, this.selectedFile.name);

      this.http.post("device-stock", formData).subscribe(
        (response) => {
          console.log("File uploaded successfully", response);
        },
        (error) => {
          console.error("Error uploading file", error);
        }
      );
    } else {
      console.error("No file selected");
    }
  }
  addLang() {
    const language = this.form.language as FormArray;
    let lang = this.makePrice();
    language.push(lang);
  }

  removeLang(i) {
    const language = this.form.language as FormArray;
    language.removeAt(i);
  }

  openModal(content: any) {
    this.submitted = false;
    this.formData = this.makeForm({ language: [{}] });
    let a = this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  onEdit(data, content) {
    console.log(data);
    console.log(content);
    this.formData = this.makeForm(data);
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  selectedIncident = null;
  selectedKeyword = null;
  exportExel() {
    this.submitFilter();
    this.eventService.setLoading(true);

    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = "reports/export-orders?" + this.params;

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        this.eventService.setLoading(false);

        // Tạo và lưu file sử dụng FileSaver
        saveAs(res, "Bao_cao.xlsx");
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất file lỗi")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  exportExelBranch() {
    this.eventService.setLoading(true);
    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = "dashboard/device-branch?model=export";

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        this.eventService.setLoading(false);

        // Tạo và lưu file sử dụng FileSaver
        saveAs(res, "Bao_cao_chi_nhanh.xlsx");
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất file lỗi")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  makeFormKeyword(d) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      id: [data.id],
      name: [data.name],
      incident_type_id: [data.incident_type_id],
    });
  }

  fetchKeyword() {
    this.dataKeyword = [];
    this.eventService.setLoading(true);
    this.apiService
      .getList(`keyword?type_id=${this.selectedIncident.id}`)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.dataKeyword = [...res];
          this.eventService.setLoading(false);
        },
      });
  }

  dataKeyword = [];

  formEditKeyword: FormGroup;
  formNewKeyword: FormGroup;
  editKeyword(data, index) {
    this.formEditKeyword = this.makeFormKeyword(data);
    this.selectedKeyword = data;
  }

  onSubmitFormKeyword(type) {
    if (type == 1) {
      if (this.formEditKeyword.valid) {
        const value = this.formEditKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.editItem("keyword", value.id, value).subscribe({
          next: (res) => {
            this.selectedKeyword = null;
            this.fetchKeyword();
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      if (this.formNewKeyword.valid) {
        const value = this.formNewKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.addItem("keyword", value).subscribe({
          next: (res) => {
            this.eventService.setLoading(false);
            this.formNewKeyword.reset({
              incident_type_id: this.selectedIncident.id,
            });
            this.fetchKeyword();
          },
        });
      }
    }
  }

  onOpenKeywordModal(content, incident) {
    this.selectedIncident = incident;
    this.fetchKeyword();
    this.formNewKeyword = this.makeFormKeyword({
      incident_type_id: this.selectedIncident.id,
    });
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  defaultPrices = [
    { condition: 1, price: 0, unit: "" },
    { condition: 2, price: 0, unit: "" },
  ];

  onDeleteKeyword(id) {
    if (id) {
      this.eventService.setLoading(true);
      this.apiService.deleteItem("keyword", id).subscribe((res) => {
        Swal.fire(
          this.translateService.instant("FORM.Success"),
          this.translateService.instant("FORM.SuccessMessageDelete"),
          "success"
        ).then((res) => {
          this.fetchKeyword();
        });
        this.eventService.setLoading(false);
      });
    }
  }

  onDelete(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant("FORM.WarningMessage"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.value) {
        this.apiService.deleteItem(this.tableName, data).subscribe((res) =>
          Swal.fire(
            this.translateService.instant("FORM.Success"),
            this.translateService.instant("FORM.SuccessMessageDelete"),
            "success"
          ).then((res) => {
            this.fetchData();
          })
        );
      }
    });
  }

  viewDetails(data: any) {
    this.router.navigate(["/invoice-manager/detail-orders/", data.order_id]);
  }

  makeForm(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      id: [data.id],
      serial_number: [data.serial_number, [Validators.required]],
      quantity: [data.quantity - data.totalAttachedDevice],
      customer_name: [data.customer_name],
      workspace_id: [data.workspace_id],
      phone: [data.phone],
      address: [data.address],
      data: [
        data.data,
        [Validators.required, Validators.min(1), Validators.max(100)],
      ],
    });
  }

  makePrices(data = []) {
    let arr = new FormArray([]);
    data.forEach((i) => {
      arr.push(this.makePrice(i));
    });
    return arr;
  }

  makePrice(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      key: [data.key, [Validators.required]],
      // price: [data.price, [Validators.required, Validators.min(0)]],
      value: [data.value, [Validators.required]],
      // id: [data.id]
    });
  }

  uploadedImage;

  saveData() {
    this.submitted = true;
    if (this.formData.valid) {
      const value = this.formData.value;
      value["status"] = value["status"] == true ? 1 : 0;
      // value['prices'][0]['condition'] = 1
      // value['prices'][1]['condition'] = 2
      // value['price']= value['prices']
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService.editItem(this.tableName, value.id, value).subscribe({
          next: (res) => {
            this.submitted = false;
            this.formData.reset();
            this.fetchData();
            this.modalService.dismissAll();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessage"),
              "success"
            );
            this.eventService.setLoading(false);
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessage"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      } else {
        this.apiService.addItem(this.tableName, value).subscribe({
          next: (res) => {
            this.fetchData();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessageAdd"),
              "success"
            );
            this.eventService.setLoading(false);
            this.modalService.dismissAll();
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessageAdd"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      console.log("invalid", this.formData);
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  goToPreviousPage() {
    if (this.pageIndex > 1) {
      this.pageIndex--;
      this.fetchData();
    }
  }

  goToNextPage() {
    if (this.pageIndex < this.totalCount) {
      this.pageIndex++;
      this.fetchData();
    }
  }
}
